import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

import { hasRight } from '#app/Common/UserCommon';
import IconAction from '#app/Component/IconAction';
import OrderPurveyorListComponent from '#app/Component/OrderPurveyorListComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { isNumber } from '#app/Util/NumberTool';
import { OrderPurveyorState, OrderPurveyorStateTranslation } from '#app/typings/orderPurveyor';

function BuyPurveyorOrderList(props) {
  const authenticationReducer = useSelector((state) => state.AuthenticationReducer);

  const getAction = (row) => {
    return (
      <>
        {hasRight(authenticationReducer, 'ROLE_BUY_ORDER_PURVEYOR') ||
        hasRight(authenticationReducer, 'ROLE_BUY_ORDER_PURVEYOR_EDIT') ? (
          <IconAction title="Modifier" icon="edit" to={getRoutePathname('buy_order_purveyor', { id: row.id })} />
        ) : hasRight(authenticationReducer, 'ROLE_BUY_ORDER_PURVEYOR_GET') ? (
          <IconAction title="Visualiser" icon="view" to={getRoutePathname('buy_order_purveyor', { id: row.id })} />
        ) : (
          <IconButton disabled={true}>
            <Edit style={{ color: '#17a2b8' }} />
          </IconButton>
        )}
      </>
    );
  };

  const promiseData = (resolve) => {
    ApiHandler.get(
      {
        route: 'api_buy_purveyor_by_purveyor_order_list',
        params: { id: props.purveyor.id },
      },
      (response) => {
        const data = response.data;
        for (const index in data) {
          data[index].state = OrderPurveyorStateTranslation[data[index].state];
          data[index].action = getAction(data[index]);
          data[index].createdAt = moment(data[index].createdAt).format('L');
          data[index].deliveryAt = (
            <span
              style={
                !data[index].deliveryAt ||
                (moment(data[index].deliveryAt).isBefore(moment()) &&
                  [OrderPurveyorState.DRAFT, OrderPurveyorState.AWAITING_RECEIPT].includes(data[index].state))
                  ? { color: '#982525' }
                  : {}
              }
            >
              {moment(data[index].deliveryAt).format('L')}
            </span>
          );
          data[index].amountTotal = isNumber(data[index].amountTotal)
            ? parseFloat(data[index].amountTotal).toLocaleString('fr-FR', { minimumFractionDigits: 2 })
            : '-';
        }
        resolve(data);
      },
    );
  };

  return (
    <OrderPurveyorListComponent
      promiseData={promiseData}
      displayActions={true}
      displayDeposit={true}
      tableId="api_buy_purveyor_by_purveyor_order_list"
    />
  );
}

export default BuyPurveyorOrderList;
